module.exports = __webpack_public_path__ + "static/media/img_apis_02.4120d00f.png";